// L'ID du tag AB Tasty arrive par les technicalVars du back-office (comme GTM_ID / ONE_TRUST_SCRIPT).
// brandMiddleware lit brand.json sur test/preprod même en localhost et en e2e (cf. middlewares.js,
// bloc `req.hostname.includes("localhost") || environment.includes("e2e")` → fallbackUrl), donc la
// simple présence de l'ID ne suffit pas comme garde : on exclut explicitement les environnements e2e,
// où le tag muterait le DOM en pleine exécution des specs Cypress.
// `includes("e2e")` couvre `e2e` et `e2e-remote`.
export const isAbTastyTagEnabled = ({ tagId, environment = "" }) => {
	return Boolean(tagId) && !environment.includes("e2e");
};

// Catégorie OneTrust « Statistical analysis cookies » : le consentement ne conditionne que la
// collecte de mesure AB Tasty, les campagnes restent affichées sans lui.
export const AB_TASTY_ONETRUST_CATEGORY_ID = "C0002";

// Relais OneTrust → AB Tasty (pas d'intégration native), inline dans le <head> avant les deux tags
// pour ne rater aucun OneTrustGroupsUpdated sans attendre l'hydratation. Dédoublonné : chaque
// révocation purge le stockage AB Tasty. @see https://docs.abtasty.com/client-side/tag/tag-javascript-events#granting-consent
export const getABTastyConsentRelayScript = () => `(function () {
	var lastIsGranted;
	window.addEventListener("OneTrustGroupsUpdated", function (event) {
		var activeGroupIds = event.detail;
		var isGranted = Array.isArray(activeGroupIds) && activeGroupIds.indexOf("${AB_TASTY_ONETRUST_CATEGORY_ID}") !== -1;
		if (isGranted === lastIsGranted) {
			return;
		}
		lastIsGranted = isGranted;
		window.abtastyGrantConsent = isGranted;
		window.dispatchEvent(new CustomEvent(isGranted ? "abtasty_grantConsent" : "abtasty_revokeConsent"));
	});
})();`;
